import { AltroSoggetto } from './altro-soggetto';
import { Incarico } from './incarico';
import { Model } from './model';

export class Riparazione extends Model {
  static apiUrl: string = "riparazioni";

  spesa: number;
  fatturata: boolean;
  numero_fattura: number;
  riparatore: AltroSoggetto;
  incarico: Incarico;

  deserialize(input: any): Riparazione {
    let retV: Riparazione = new Riparazione();
    retV = super.deserialize(input) as Riparazione;

    if (input?.riparatore)
      retV.riparatore = new AltroSoggetto().deserialize(input.riparatore);

    if (input?.incarico)
      retV.incarico = new Incarico().deserialize(input.incarico);


    return retV;
  }

  public getHumanIdentifier() {
    return `${this.riparatore?.nome}: ${this.spesa} €`;
  }

}
